import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "../../../helper/axios"
import AutoPostToBank from "./AutoPostToBank";

export default function Paynow() {
    const [payload, setPayload] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();

    const orderId = location.state?.orderId;
    const amount = location.state?.amount;
    const transId = location.state?.transId;

    // const orderId = Math.random();
    // const amount = 500;

    useEffect(() => {
        if (!orderId || !amount) {
            // Safety: if someone hits /pay directly
            navigate("/checkout");
            return;
        }
        (async () => {


            try {
                const res = await axios.post("/paynow/initiate", {
                    amount,
                    currency: 978,
                    oid: orderId,
                    transId: transId

                });

                const data = res.data;
                console.log("[PAYMENT GATEWAY] final payload:", data);
                setPayload(data);
            } catch (error) {
                console.error("Error initiating payment:", error);
            }


            // const res = await fetch("payments/initiate", {
            //     method: "POST",
            //     headers: { "Content-Type": "application/json" },
            //     body: JSON.stringify({ amount, currency: 949, oid: orderId }),
            // });
            // const data = await res.json();




        })();
    }, [orderId, amount, navigate]);

    if (!payload) return <div>Preparing secure payment…</div>;
    return <AutoPostToBank payload={payload} />;
}
